/**
 * @Author:
 * @Description:
 * @DateTime: Created in 2020-11-30 18:57:40
 */

import SystemSet from '../systemSet';
import { Toast } from 'src/util/toast';
import { default as CellOperate } from 'src/components/agGridComponent/cellOperate';
import { IconBtnItem } from 'src/components/iconBtnGroup/iconBtnGroup';
import { ColDefCustom, default as AgGridVueCustomTsx } from 'src/components/agGridCustom/agGridVueCustomTsx';
import SystemSetApi, { SystemSetDOI } from '../api/systemSetApi';
import _ from 'lodash';
import ListPageService from 'src/types/ListPage';
import override from 'src/dectorators/override';
import { QueryFormVOI } from 'src/components/queryForm/queryForm';
import alertStationOperateModal from '../systemSetOperateModal';
import EnumOperates from 'src/enums/enumOperates';

export default class SystemSetService extends ListPageService {
    ctx: SystemSet;
    type: any;

    constructor(ctx: SystemSet) {
        super();
        this.ctx = ctx;
    }

    @override
    createColumns(): ColDefCustom[] {
        let t = this;
        return [
            {
                headerName: '站点名称',
                field: 'name',
                minWidth: 80,
            },
            {
                headerName: 'ip地址',
                field: 'ip',
                minWidth: 100,
            },
            {
                headerName: '端口',
                field: 'port',
                minWidth: 140,
            },
            {
                headerName: '操作',
                field: 'operate',
                minWidth: 120,
                maxWidth: 120,
                cellRendererFramework: CellOperate,
                cellRendererFrameworkOpt: [
                    {
                        text: '修改',
                        async click(params) {
                            let data: SystemSetDOI.RowDataI = params.data;
                            let res = await alertStationOperateModal(EnumOperates.Update.getName(), data.id);
                            if (res) {
                                t.searchTable();
                            }
                        },
                    },
                    {
                        text: '删除',
                        async click(params) {
                            let res = await Toast.confirm();
                            if (!res) {
                                return;
                            }
                            let data: SystemSetDOI.RowDataI = params.data;
                            await t.delete(data.id);
                        },
                    },
                ],
            },
        ];
    }

    @override
    createBtnGroup(): Array<IconBtnItem> {
        let t = this;
        return [
            {
                text: '新增',
                async onClick() {
                    let res = await alertStationOperateModal(EnumOperates.Add.getName());
                    if (res) {
                        t.searchTable();
                    }
                },
            },
            // {
            //     text: '删除',
            //     type: 'info',
            //     async onClick() {
            //         let gridOptions: any = t.ctx.gridOptions;
            //         let selectRows: SystemSetDOI.RowDataI[] = gridOptions.api.getSelectedRows();
            //         if (selectRows.length === 0) {
            //             return Toast.warning('请选择要操作的数据');
            //         }
            //         let res = await Toast.confirm();
            //         if (!res) {
            //             return;
            //         }
            //         let ids: number[] = selectRows.map(item => item.id);
            //         await t.delete(ids);
            //     },
            // },
        ];
    }
    async delete(id: number) {
        let { code } = await SystemSetApi.deleteDevice({ id: id });
        if (code === 0) {
            Toast.success('删除成功');
            this.searchTable();
        }
    }

    @override
    creatQueryForm(): QueryFormVOI.DateItemType[] {
        return [
            // {
            //     component: CommonSelect,
            //     label: '站点类型',
            //     field: 'type',
            //     labelWidth: 60,
            //     width:160,
            //     props: { value: null, dataSource: EnumStationType.getList() },
            // },
            // {
            //     component: AreaCascader,
            //     label: '区域',
            //     field: 'area：',
            //     width: 300,
            //     labelWidth: 40,
            //     dealParam(value) {
            //         return {
            //             province_id: value[0],
            //             city_id: value[1],
            //             district_id: value[2],
            //         };
            //     },
            //     props: { value: [], type: this.type },
            // },
            // {
            //     component: EntitySelect,
            //     label: '所属流域',
            //     field: 'basin_id',
            //     labelWidth: 60,
            //     width:160,
            //     props: { value: null, type: EnumEntity.Basin.getId() },
            // },
            // {
            //     component: EntitySelect,
            //     label: '通讯协议',
            //     field: 'agreement_id',
            //     labelWidth: 60,
            //     width:160,
            //     props: { value: null, type: EnumEntity.Agreement.getId() },
            // },
            // {
            //     component: Input,
            //     label: '',
            //     labelWidth: 20,
            //     field: 'name_mn',
            //     props: { value: '', placeholder: '请输入站点名称/mn号' },
            // },
        ];
    }

    @override
    initSearchParams(): void {
        this.ctx.searchParams = this.ctx.queryForm.getQueryObj<SystemSetDOI.QueryRowDataParamsI>();
        this.ctx.currentPage = 1;
    }

    @override
    async searchTable() {
        let ctx = this.ctx;
        let ag = this.ctx.$refs.ag as AgGridVueCustomTsx;
        ag.showLoading();
        let { code, data } = await SystemSetApi.listDevicePage({
            // ...ctx.searchParams,
            page_size: ctx.pageSize,
            page_index: ctx.currentPage,
        });
        ag.hideLoading();

        if (code === 0) {
            ctx.rowData = data.data_info || [];
            ctx.total = data.page_count;
        }
    }
}
